module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-square p0202"
  }, [_c('div', {
    staticClass: "menu-vertical-item",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "menu-body"
  }, [_vm._v("\n      " + _vm._s(_vm.time) + "\n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('selector-time', {
    ref: "time",
    attrs: {
      "position": "bottom",
      "time": _vm.time,
      "minTime": "14:25",
      "maxTime": "14:25",
      "minStep": "5"
    },
    on: {
      "on-submit": _vm.submit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-dock"
  }, [_c('i', {
    staticClass: "icon iconfont icon-unfold"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf3367be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selector-time/demo.vue
// module id = 278
// module chunks = 4